export const MENU_MIN_WIDTH = 300;
export const INVITE_PEOPLE_ID = '__INVITE_PEOPLE_ID__';
export const UNASSIGNED_ID = 'unassigned';
export const ASSIGN_TO_ME_ID = 'assignToMe';
export const AUTOMATIC_ID = 'automatic';
export const AUTOMATIC_ID_VALUE = '-1';
